<template>
    <div>
        <div v-if="Object.keys(discounts).length > 0">
            <hr class="my-2">
            <div v-if="Object.keys(discounts).length > 0">
                <div class="d-flex align-items-center justify-content-between">
                    <small>Discounts</small>
                    <small class="clear-discounts text-primary" @click="customClearDiscounts()">Clear Discounts</small>
                </div>
                <div v-for="(basketDiscount, key) in discounts" :key="basketDiscount.id">
                    <div class="d-flex justify-content-between align-items-center py-2">
                        <template v-if="key != 'total_discount' && basketDiscount.type != 'promo_entry'">
                            <span class="flex-fill text-danger fw-bold">{{ basketDiscount.discount_name }}</span>
                            <span class="text-danger fw-bold">-&pound;{{ basketDiscount.discount_amount }}</span>
                        </template>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(promoEntries).length > 0">
                <small>Promotions entered</small>
                <div v-for="(basketDiscount, key) in promoEntries" :key="key" class="d-flex justify-content-between align-items-center py-2">
                    <template v-if="basketDiscount.type == 'promo_entry'">
                        <span class="flex-fill text-danger fw-bold">{{ basketDiscount.discount_name }}</span>
                        <span class="text-danger fw-bold">{{ basketDiscount.discount_code }}</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Field , ErrorMessage} from 'vee-validate';
    import discount from '@shared/mixins/discount';
    export default {
        props: ['basket'],
        mixins: [discount],
        components: { Field, ErrorMessage },
        methods: {
            async customClearDiscounts() {
                this.emitter.emit('isLoading', true);

                const response = await axios.post('/ajax/clear_discounts/');

                if(response.data.success) {
                    this.emitter.emit('refreshBasket');
                    this.emitter.emit('clearDiscountField');
                }

                this.emitter.emit('isLoading', false);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .clear-discounts {
        text-decoration: underline;
        cursor: pointer;
    }
    .text-red {
        color: #D43030;
    }
</style>